import React, { useState } from "react";
import TextArea from "Components/TextArea";
import "./styles.scss";
import MachineInformation from "Components/Request/FailureAnalysisRequest/MachineInformation";
import BearingUseInformation from "Components/Request/FailureAnalysisRequest/BearingUseInformation";
import LubricationDetails from "Components/Request/FailureAnalysisRequest/LubricationDetails";
import FailureDetails from "Components/Request/FailureAnalysisRequest/FailureDetails";
import { useLocation } from "react-router-dom";

const Appendix = ({ formMethods, selectedFile, setSelectedFile }) => {
  const location = useLocation();
  const { remote_failure_details_id } = location.state;

  return (
    <div className="">
      <FailureDetails farId={remote_failure_details_id}/>
      <MachineInformation farId={remote_failure_details_id}/>
      <BearingUseInformation farId={remote_failure_details_id}/>
      <LubricationDetails farId={remote_failure_details_id}/>
    </div>
  );
};

export default Appendix;
